import { Network } from '../../../utils/network'
import { Events } from '../../../utils/servicesEvents'
import { Formatter } from '../formatter'
import { connectWithOtp } from './connectWithOtp'
import { resolvePhoneNumber } from './resolvePhoneNumber'

import urls from './urls.json'

async function launchTransaction(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  let url = urls.launchTransaction.wallet

  let userData, phonePrefix, countryCode
  phonePrefix = data.selectedCountry?.phonePrefix
  countryCode = data.selectedCountry?.countryCode

  console.log(data)

  if (data.isDirectSubscription || data.isDirect) {
    const connection = await connectWithOtp(data)
    if (!connection.success) return { notLaunched: true, badConnection: true }
    userData = connection.user
  } else {
    userData = await self.servicesVars.getUserData()
    phonePrefix ||= await self.servicesVars.getUserCountryPrefix()
    countryCode ||= await self.servicesVars.getUserCountryCode()
  }

  let body = {
    ...data,
    amount: data.amount,
    firstName: userData.firstName,
    lastName: userData.lastName,
    userId: userData.reference || userData.id,
    currency: /ga/i.test(countryCode) ? 'XAF' : 'XOF',
    withdrawalCode: data.withdrawalCode,
    cryptoSellingReference: data.cryptoSellingReference,
    countryCode,
  }

  const needPhoneNumber = /momo/i.test(data.src) || /momo/i.test(data.dst)
  if (needPhoneNumber) {
    if (/bj/i.test(countryCode) && !`${data.phoneNumber}`.startsWith('01')) {
      data.phoneNumber = `01${data.phoneNumber}`
    }
    body.phoneNumber = `${phonePrefix}${data.phoneNumber}`
    if (data.externalWallet) {
      body.operator = data.externalWallet
    } else {
      const phoneDetails = await resolvePhoneNumber({
        phoneNumber: body.phoneNumber,
        countryCode,
      })
      if (!phoneDetails.success || !phoneDetails.decoded.carrier)
        return { notLaunched: true, badPhoneNumber: true }
      body.operator = phoneDetails.decoded.carrier
      body.phoneNumber = phoneDetails.decoded.internationalNumber
    }
  }

  if (
    body.phoneNumber &&
    body.operator?.toUpperCase() == 'ORANGE' &&
    /momo/i.test(data.src) &&
    (!body.manualCollectInfos || !body.manualCollectInfos['Code Otp'])
  ) {
    const totalToPay = await calculateTotalToPay(body)
    const otpUssdString = await getOtpUssdString(countryCode, totalToPay)
    return {
      notLaunched: true,
      reason: 'require_manual_operation_info',
      error: {
        data: {
          operator: 'ORANGE',
          country: countryCode,
          title: `Transférez ${body.amount} FCFA`,
          instructions: [
            {
              text: 'Etape 1 : Tapez le code USSD suivant',
              type: 'double',
              option1: {
                text: `Cliquez & Lancez  ${otpUssdString}`,
                actionContent: `${otpUssdString}`,
                action: 'tel',
              },
              option2: {
                text: `Cliquez & Copiez  ${otpUssdString}`,
                actionContent: `${otpUssdString}`,
                action: 'copy',
              },
            },
            {
              text: 'Etape 2 : Entre votre code secret pour générer le code',
              actionContent: '',
              action: '',
            },
            {
              text: 'Etape 3 : Entrez la code généré dans le champ ci-dessous',
              actionContent: '',
              action: '',
            },
          ],
          requiredFields: [
            {
              label: 'Code Otp',
              placeHolder: 'xxxx',
              type: 'text',
            },
          ],
        },
      },
    }
  } else if (
    body.phoneNumber &&
    body.operator?.toUpperCase() == 'ORANGE' &&
    /momo/i.test(data.src) &&
    body.manualCollectInfos &&
    body.manualCollectInfos['Code Otp']
  ) {
    body.otp = body.manualCollectInfos['Code Otp']
    delete body.manualCollectInfos
    delete body.manualInfoAdded
  }

  const platformData = await Events.sendDataRequestResolve('platformData')
  if (platformData) {
    body.platform = platformData.platform || ''
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

async function calculateTotalToPay(data) {
  let { amount, src, dst, bookmaker, countryCode } = data
  if (src == 'bookmaker') src = bookmaker
  if (dst == 'bookmaker') dst = bookmaker
  const serverFeeResponse = await Events.sendDataRequestResolve(
    'calculateFees',
    {
      amount,
      src,
      dst,
      countryCode,
    },
  )
  return serverFeeResponse.srcAmount
}

async function requestOtpCode(countryCode, amount) {
  const otpUssdString = getOtpUssdString(countryCode, amount)
  if (!otpUssdString) return null
  const prompt = await Events.sendDataRequestResolve(
    'customPrompt',
    {
      title: otpUssdString,
      subTitle: "Veuillez générer le code otp pour lancer l'opération",
      formFields: [
        {
          type: 'text',
          propertyName: 'otpCode',
          label: 'Code otp',
          defaultValue: '',
          required: true,
        },
      ],
      successText: 'Continuer',
    },
    9999999999,
  )
  console.log(prompt)
  if (!prompt.accepted) return null
  return `${prompt.data.otpCode}`.trim()
}

async function getOtpUssdString(countryCode, amount) {
  const otpUssdCodes = await Events.sendDataRequestResolve('otpUssdCodes')
  if (!otpUssdCodes?.metaData || !otpUssdCodes?.metaData[countryCode]) {
    return null
  }
  const otpCodeConfig = otpUssdCodes?.metaData[countryCode]
  return otpCodeConfig.ussdCode.replace(/{amount}/g, amount)
}

function parseResponse(response) {
  if (response?.notLaunched) {
    return {
      ...response,
      success: false,
    }
  }
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
      data: response.response?.data,
    }
  }
  if (response && response.status.code === 400) {
    return {
      success: false,
      reason: response?.response?.error?.error || 'unknown',
      error: response?.response?.error,
    }
  }
  if (response === null || response.status.code === 404) {
    return {
      success: false,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { launchTransaction }
